import { BUS_TOPIC_SGCONNECT_USER_INFO, getWidgetBus, UserInfo } from '@sgwt/react-shared-libs';
import { SgwtChatbotConfiguration } from '@sgwt/sgwt-widgets-react/dist/sgwt-help-center/types';

export const BUS_TOPIC_SGCONNECT_ACCESSTOKEN = 'sg-connect.access-token';

type BusEventCallback<T> = (payload: T | undefined) => void;
// eslint-disable-next-line react-hooks/exhaustive-deps
type SubscriptionHandle = any;

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}
export interface SgWidgetsBus {
  dangerouslyGetCurrentValue<T>(topicName: string): T | undefined;
  subscribe<T>(topicName: string, cb: BusEventCallback<T>): SubscriptionHandle;
  unsubscribe(handle: SubscriptionHandle): void;
}

export function getWidget<T extends HTMLElement>(tagName: string): T {
  return document.querySelector(tagName) as T;
}

export function getAuthorizationHeader(): string | undefined {
  const bus = getWidgetBus();
  if (bus) {
    return bus.dangerouslyGetCurrentValue<string>(BUS_TOPIC_SGCONNECT_ACCESSTOKEN);
  }
  return undefined;
}

export function getAccessToken(): string | null {
  const bus = getWidgetBus();
  if (bus) {
    const token = bus.dangerouslyGetCurrentValue<string | undefined>(BUS_TOPIC_SGCONNECT_ACCESSTOKEN);
    return token || null;
  }
  return null;
}

export function getSgConnectUserInfo(): UserInfo<string> | undefined {
  const bus = getWidgetBus();
  if (bus) {
    return bus.dangerouslyGetCurrentValue<UserInfo<string> | undefined>(BUS_TOPIC_SGCONNECT_USER_INFO);
  }
  return undefined;
}

export const chatbotConfiguration: SgwtChatbotConfiguration = {
  adapter: 'dx-assistant',
  knowledgeSpace: 'dx',
};

export * from './application';
export * from './certification';
export * from './component';
export * from './constant';
export * from './deviance';
export * from './flag';
export * from './reference';
export * from './roadmap';
export * from './scope';
